module.exports = __webpack_public_path__ + "static/media/lhs.dbe08f37.png";